export enum SidebarView {
    Hide,
    Filters,
    Quickview,
}